<template>
	<!--
<AddFile v-for="(file,index) in fileList"
	:name="'asd'"
	:file="file"

	:verification="'notEmpty'"
	:addClass="{'asd':true}"
	:accept="'.jpg,.png'"
	@Upload="replaceFile(arguments[0],index)"
	@Remove="removeFile(arguments[0],index)"

	:key="index"
></AddFile>
<AddFile :name="'asd'" :key="'asd'" :mode="'upload'" @Upload="addFile" @Remove="removeFile"></AddFile>

myFile:{
	src:"",
	name:"",
	type:"",
	fullName:name+"."+type,
	size:0
}

@Select:{
	name:"",
	file:myFile
}
@Upload:{
	name:"",
	file:myFile,
	fileStr:"myFile"
}

https://lian-yue.github.io/vue-upload-component/#/zh-cn/documents#%E9%80%89%E9%A1%B9-%E5%B1%9E%E6%80%A7-post-action

xlsx,xls
:accept="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel'"

post-action="/upload-s/igen-store/uploadObject"
 -->
	<FileUpload
		class="addFile hover-c-primary tra-fast"
		:class="sizeClass"
		:style="{ 'vertical-align': mode != 'textButton' ? 'top' : 'middle' }"
		:headers="{ Authorization: `Bearer ${token}` }"
		:ref="myId"
		:addFile="myId"
		:title="myFile.fullName || (myFile.name ? myFile.name + '.' + myFile.type : $t('word3', ['选择文件']))"
		:data="{ pathKey: pathKey }"
		:post-action="api"
		:extensions="extensions"
		:accept="accept"
		:multiple="mult"
		:drop="true"
		@input-filter="inputFilter"
		@input-file="inputFile"
	>
		<!--
:id="myId"
v-model="file"
accept="image/png,image/gif,image/jpeg,image/webp"
extensions="gif,jpg,jpeg,png,webp"
:size="1024 * .1"
 -->
		<div
			v-if="mode != 'textButton'"
			slot="btn"
			:href="mode == 'view' ? myFile.src : null"
			:target="mode == 'view' ? '_blank' : null"
			:download="mode == 'view' ? myFile.fullName : null"
		>
			<div
				v-if="sizeClass != 'xs' && picMode == 'cover'"
				class="view mc boxR ofH posR tra-fast"
				:class="[{ bdSub: fileType == '', noFile: fileType == '', 'hover-bg-highLight': fileType == '' }]"
			>
				<!-- <input type="file"> -->
				<div
					v-if="fileType == 'image' && picMode == 'cover'"
					class="pic boxR tra-fast"
					:style="{ 'background-image': 'url(' + (fileType == 'image' ? myFile.src : '') + ')' }"
				>
					<div class="plus-progress tra" :progress="progress" :style="{ height: 100 - progress + '%' }"></div>
				</div>

				<svg v-if="fileType == 'excel'"><use xlink:href="#file-excel" /></svg>
				<svg v-if="fileType == 'word'"><use xlink:href="#file-word" /></svg>
				<svg v-if="fileType == 'pdf'"><use xlink:href="#file-pdf" /></svg>
				<svg v-if="fileType == 'text'"><use xlink:href="#file-text" /></svg>
				<svg v-if="fileType == 'unknow'"><use xlink:href="#file-unknow" /></svg>
				<!-- <svg v-if="fileType=='image'"><use xlink:href="#file-break" /></svg> -->
				<svg v-if="fileType == 'break'"><use xlink:href="#file-break" /></svg>
				<div v-if="myFile.name && mode != 'view'" class="edit textCut tra-fast">{{ $t("device256", ["修改"]) }}</div>
				<div v-if="removeBtn && myFile.name && mode != 'view'" class="remove tra-fast" @click.prevent="remove" :title="$t('cmd121', ['点击移除'])">
					<Icon name="close" />
				</div>
			</div>
			<!-- 
		<div v-if="picMode=='free'" class="view boxR ofH" :class="{'w7x h7x mc':!myFile.name}">
			<Icon v-if="!myFile.name" name="photo" class="w6x h6x fSub" />
			<img :src="myFile.src" class="w100pct boxR">
			<div v-if="myFile.name&&mode!='view'" class="edit textCut tra-fast">{{$t('device256',['修改'])}}</div>
			<div v-if="removeBtn&&myFile.name&&mode!='view'" class="remove tra-fast" @click.prevent="remove" :title="$t('cmd121',['点击移除'])"><Icon name="close" /></div>
			<div class="plus-progress bgSub boxR-bottom ofH tra-fast" status="hide">
				<div class="bgPrimary tra" :style="{width:progress+'%'}"></div>
			</div>
		</div>
		<div v-if="text&&!myFile.src" class="mt1x cSub">{{text}}</div>
		 -->
			<div v-if="picMode == 'free'" class="view tableSys bgLight boxR hover-bg-highLight ofH tra-fast">
				<div class="vaM" :style="{ 'background-image': 'url(' + (fileType == 'image' ? myFile.src : '') + ')' }" fillHeight="width">
					<Icon v-if="!myFile.name" name="photo" class="w4x h4x fSub" />
					<!-- <img :src="myFile.src" class="w100pct boxR"> -->
					<div v-if="myFile.name && mode != 'view'" class="edit textCut tra-fast">{{ $t("device256", ["修改"]) }}</div>
					<div v-if="removeBtn && myFile.name && mode != 'view'" class="remove tra-fast" @click.prevent="remove" :title="$t('cmd121', ['点击移除'])">
						<Icon name="close" />
					</div>
					<div class="plus-progress bgSub boxR-bottom ofH tra-fast" status="hide">
						<div class="bgPrimary tra" :style="{ width: progress + '%' }"></div>
					</div>
					<div v-if="text && !myFile.src" class="mt1x cSub">{{ text }}</div>
				</div>
			</div>
			<div v-if="toolDisplay && myFile.name" class="fileName lh20 taC vaM_E">
				<div class="dpIB cb tra-fast textCut_E fL_E">
					<span class="name">{{ myFile.name }}</span>
					<span v-show="myFile.name && myFile.type" class="type">{{ "." + myFile.type }}</span>
				</div>
			</div>
			<div v-if="toolDisplay && myFile.size" class="fileSize cSub">{{ fileSizeFormat(myFile.size) + (progress < 100 ? "(" + progress + "%)" : "") }}</div>
			<!--
		<div class="fileName lh13 textCut_E h2x_E dpIB_E vaM_E">
			<span class="name">{{name}}</span>
			<span v-show="name" class="w2x-max">{{"."+fileType}}</span>
		</div>
		 -->
			<a
				v-if="toolDisplay && myFile.src"
				:href="myFile.src"
				target="_blank"
				:download="decodeURIComponent(myFile.fullName)"
				class="cField mt05x fs14x fa fa-download"
				:title="$t('cmd114', ['下载'])"
			></a>
			<div v-if="error" class="mt05x cError">{{ error }}</div>
		</div>
		<div v-if="mode == 'textButton'" slot="btn">{{ text }}</div>
	</FileUpload>
</template>
<script>
import FileUpload from "@/components/common/file-upload/FileUpload";
import * as lib from "@/util/lib.js";
import translate from "@/util/errorCode.js";
import * as authUtils from "@/util/auth";

let defFile = {
	name: "",
	fullName: "",
	type: "",
	src: "",
	size: 0,
};
export default {
	name: "AddFile",
	components: { FileUpload },
	props: {
		api: {
			type: String,
			default: "/store-s/uploadObject",
		},
		name: {
			//可用于识别对应身份及你能想到的任何用途
			type: String,
			default: "",
		},
		pathKey: {
			type: String,
			default: "temp",
		},
		// src:{
		// 	type:String,
		// 	default:""
		// },
		// fileName:{
		// 	type:String,
		// 	default:""
		// },
		// fileType:{
		// 	type:String,
		// 	default:""
		// },
		verification: {
			type: String,
			default: "",
		},
		file: {
			type: [Object, String],
			default: function () {
				return {};
			},
		},
		mult: {
			type: Boolean,
			default: false,
		},
		mode: {
			type: String,
			default: "", //upload:仅选择文件及上传，完成后不展示,view:展示选择的文件或图标,textButton:仅文本按钮
		},
		picMode: {
			//图片格式的展示形式
			type: String,
			default: "cover",
		},
		removeBtn: {
			//删除按钮控制
			type: Boolean,
			default: true,
		},
		toolDisplay: {
			//其它内容呈现控制
			type: Boolean,
			default: true,
		},
		addClass: {
			//附加class
			type: [String, Object],
			default: "",
		},
		viewSize: {
			//xs,s,m,l,xl
			type: String,
			default: "m",
		},
		maxSize: {
			type: Number,
			default: 1024 * 1024 * 5,
		},
		extensions: {
			type: Array,
			default: () => [],
		},
		accept: {
			type: String,
			default: "",
		},
		text: {
			type: String,
			default: "",
		},
	},
	data() {
		return {
			myId: "addFile" + Math.round(Math.random() * 9999),
			sizeClass: "",
			myClass: this.addClass,

			// myFileName:this.fileName,
			// myFileType:this.fileType,
			// mySrc:this.src,
			// myFile:$.parseJSON(this.file.replace(/'/g,'"')),
			myFile: this.file,
			fileType: "",
			selectFile: "",
			// fileSize:0,
			remoteSrc: "",
			progress: 100,
			error: "", //报错文本
			token: authUtils.getToken(),
		};
	},
	watch: {
		addClass: function (data) {
			//自定样式和尺寸样式合并
			if ($.isPlainObject(data)) {
				this.$nextTick(function () {
					this.$set(this.myClass, this.sizeClass, true);
				});
			} else this.$set(this, "myClass", this.addClass + " " + this.sizeClass);
		},
		sizeClass: function () {
			//自定样式和尺寸样式合并
			if ($.isPlainObject(this.addClass)) {
				// this.$set(this,"myClass",$.extend({},this.addCLass,{[this.sizeClass]:true}));
				this.$nextTick(function () {
					this.$set(this.myClass, this.sizeClass, true);
				});
			} else this.$set(this, "myClass", this.addClass + " " + this.sizeClass);
		},
		file: {
			deep: true,
			handler: function (data) {
				//外部变化数据后重新解析数据，例如在外部的数组发生变化
				// this.$set(this,"myFile",$.parseJSON(data.replace(/'/g,'"')));
				this.myFile = this.stringToFile(data); //trace(this.myFile)
				this.readFileType();
			},
		},
		progress: function (nV, oV) {
			//依据进度判断上传进度条的呈现
			if (nV == 0 && oV != 0) {
				$(this.$el).find(".progress[status]").attr("status", "show");
			} else if (nV == 100) {
				setTimeout(() => {
					$(this.$el).find(".progress[status]").attr("status", "hide");
				}, 1000 * 2);
			}
		},
	},
	methods: {
		// canPreview:function(){
		// 	let previewType=["jpg","jpeg","gif","png","svg","bmp"];
		// 	if(previewType.indexOf(this.myFile.type.toLowerCase())>=0) return true;
		// 	else return false;
		// },
		reset() {
			this.error = "";
			this.fileType = "";
			this.clear(); //会影响租金表信息的获取
		},
		doVerification: function () {
			let optionArray = this.verification.split(",");
			let $this = this;
			$.each(optionArray, function () {
				let option = this.split(":");
				switch (option[0]) {
					case "notEmpty":
						// if(!$this.myFile.name){
						// 	$this.error=option[1];
						// 	return false;
						// }
						if (!$this.remoteSrc) {
							$this.error = option[1];
							return false;
						}
						break;
				}
			});
			if (this.error) return false;
			//验证不通过：false
			else return true; //验证通过：true
		},
		stringToFile: function (string) {
			function getName(src) {
				let fullName = src.split("/");
				fullName = fullName[fullName.length - 1];
				return fullName.split(".");
			}
			let file = {};
			// if(string==""){
			// 	// file=null;
			// }else
			if ($.type(string) == "string") {
				this.remoteSrc = string;
				let namePart = getName(string);
				// console.log(namePart)
				$.extend(true, file, defFile, {
					fullName: namePart.join("."),
					name: namePart[0],
					type: namePart[1],
					src: string,
				});
				return file;
			} else if ($.isEmptyObject(string) == false) {
				// if(!this.myFile.type){//如果没有type，根据src重新生成并赋值
				// }
				let namePart = getName(string.src);
				$.extend(true, file, defFile, string, {
					fullName: string.name + "." + namePart[1],
					// name:namePart[0],
					type: namePart[1],
					// src:string
				});
				return file;
				// $.extend(true,this.myFile,{type:namePart[1]});
				// return {...string, fullName: `${string.name}.${namePart[1]}`}
			} else return $.extend(true, {}, defFile);
		},
		readFileType: function () {
			//trace(this.myFile.fullName)
			if ($.isEmptyObject(this.myFile) == false && this.myFile.src) {
				let type = "";
				let image = ["jpg", "jpeg", "gif", "png", "svg", "bmp"]; //tif,eps,tga不可以
				let word = ["doc", "docx"];
				let excel = ["xls", "xlsx"];
				let text = ["txt"];
				let pdf = ["pdf"];
				let typeMap = { image, word, excel, text, pdf };

				let fileType = this.myFile.type.toLowerCase(); //转成小写，准备匹配
				$.each(typeMap, function (key) {
					//遍历匹配格式
					if (type == "") {
						if (this.indexOf(fileType) >= 0) {
							type = key;
						}
					} else return;
				});
				if (type == "") type = "unknow";
				this.$set(this, "fileType", type);
				return type;
			}
		},
		fileSizeFormat: function (byte) {
			let lvG = 1024 * 1024 * 1024;
			let lvM = 1024 * 1024;

			if (byte > lvG) return Math.round((byte / 1024 / 1024 / 1024) * 100) / 100 + "G";
			else if (byte > lvM) return Math.round((byte / 1024 / 1024) * 100) / 100 + "M";
			else return Math.round((byte / 1024) * 100) / 100 + "K";
		},
		inputFilter(newFile, oldFile, prevent) {
			// trace(oldFile);
			if (newFile) {
				this.$emit("error", false);
				let fileFullName = newFile.name.split(".");
				if (newFile.size > this.maxSize) {
					//error
					this.$notify(i18n.t("fill3rd13", [this.maxSize / 1024 / 1024, "文件不超过{0}MB"]));
					return prevent();
				} else if (this.accept && $.inArray(fileFullName[fileFullName.length - 1].toLowerCase(), this.accept.replace(/\./g, "").split(",")) < 0)
					this.$notify(i18n.t("fill3rd98", [this.accept, "该文件类型不允许上传。请上传[{0}]类型的文件"]));
				else {
					this.$set(this, "selectFile", newFile);
					this.$set(this.myFile, "type", fileFullName.pop());
					this.$set(this.myFile, "name", fileFullName.length > 1 ? fileFullName.join(".") : fileFullName[0]);

					// if(this.readFileType()=="image") this.$set(this.myFile,"src",URL.createObjectURL(newFile.file));//可预览格式直接呈现
					// else{//根据扩展名选择对应图标
					// 	// this.$set(this,"mySrc",URL.createObjectURL($("#"+this.myId).find("[type='file']")[0].files[0]));
					// 	switch(this.myFile.type){
					// 		case "":break;
					// 		default:break;
					// 	}
					// }
					// this.$set(this,"progress",0);
					newFile.active = true;
					// this.$set(this,"mySrc",URL.createObjectURL(new Blob([newFile],{type:"application/image"})) );
					this.$emit(
						"Select",
						$.extend(
							true,
							{},
							{
								name: this.name,
								file: this.myFile,
							}
						)
					);
					this.readFileType();
					// console.log(1)

					if (!oldFile || newFile.id != oldFile.id) {
						this.myFile.src = URL.createObjectURL(newFile.file);
						this.$nextTick(() => {
							lib.fillHeight();
						});
					}
				}
				// this.$emit("Select",newFile);
			}
		},
		inputFile(newFile, oldFile) {
			// trace(newFile)
			if (newFile) {
				this.$emit("Uploading", Number(newFile.progress.split(".")[0]));
				this.$set(this, "progress", Number(newFile.progress.split(".")[0]));
				this.$set(this.myFile, "size", Math.round(newFile.size * this.progress) / 100);
				if (newFile.success) {
					// trace(newFile)
					if (typeof newFile.response == "string") {
						this.$set(this, "remoteSrc", newFile.response); //newFile.response&&newFile.response!=this.remoteFile
					} else {
						this.$set(this, "remoteSrc", newFile.response.url); //newFile.response&&newFile.response!=this.remoteFile
					}
					this.$set(this.myFile, "size", newFile.size);

					let $this = this;
					let requestFile = $.extend({}, this.myFile, {
						fullName: (function () {
							let name = "";
							if ($this.myFile.name) {
								name = $this.myFile.name + ($this.myFile.type ? "." + $this.myFile.type : "");
							}
							return name;
						})(),
						src: this.remoteSrc,
					}); //trace(requestFile.fullName)
					this.$emit(
						"Upload",
						$.extend(
							true,
							{},
							{
								name: this.name,
								file: requestFile,
							}
							// ,{
							// 	fileStr:JSON.stringify(requestFile)
							// }
						)
					);

					// formModeChange($("[addFile='"+this.myId+"']")[0],"update");//更新编辑模式的高度
					if (this.mode === "upload") this.clear();
					this.error = "";
				} else if (newFile.response.code) {
					//上传失败后
					this.clear();
					// trace(translate)
					this.$notify(translate(newFile.response.code));
				}
			}
		},
		clear: function () {
			this.$refs[this.myId].remove(this.selectFile);
			this.$set(this, "selectFile", "");
			this.$set(this, "fileType", "");
			this.$set(this, "remoteSrc", "");
			this.$set(this, "myFile", $.extend({}, defFile));
		},
		remove: function () {
			//trace(this.)
			this.$emit("Remove", {
				name: this.name,
				file: { src: this.myFile },
			});
			this.clear();
			// this.$set(this,"fileSize",0);
			// this.$set(this,"mySrc","");
			// this.$set(this,"myFileName","");
			// this.$set(this,"myFileType","");
		},
		download: function () {
			if (this.mode == "view") {
				window.open(this.myFile.src);
			}
		},
	},
	created() {
		if (this.picMode == "cover") {
			switch (this.viewSize) {
				case "m":
					this.$set(this, "sizeClass", "addFile-m");
					break;
				case "l":
					this.$set(this, "sizeClass", "addFile-l");
					break;
				default:
					this.sizeClass = "addFile-" + this.viewSize;
					break;
			}
		} else {
			this.sizeClass = "addFile-free";
		}
		this.myFile = this.stringToFile(this.file);
	},
	mounted() {
		// this.myFile=this.stringToFile(data);//trace(this.myFile)
		this.$nextTick(() => {
			lib.fillHeight();
		});
		this.readFileType();
		// $("[addFile='"+this.myId+"']").addClass(this.sizeClass);
		// $("#"+this.myId).addClass(this.sizeClass);//自动添加尺寸class
		// trace($("#"+this.myId).attr("class"))
		if (this.mode == "view")
			$("[addFile='" + this.myId + "']")
				.find("[type='file']")
				.remove();

		// this.readFileType();
	},
};
</script>
<style lang="scss" scoped>
.addFile {
	position: relative;
	display: inline-block;
	min-height: 2.5em;
	overflow: hidden;
	line-height: 1;
	cursor: pointer;
	[type="file"] {
		position: absolute;
		top: -100%;
	}

	&.addFile-noBG {
		&:before,
		&:after {
			display: none;
		}
	}
	.pic {
		position: absolute;
		top: 0;
		left: 0;
		z-index: 1;
		width: 100%;
		height: 100%;
		text-align: center;
		background-repeat: no-repeat;
		background-position: center;
		background-size: cover; //contain
		[progress] {
			position: absolute;
			top: 0;
			width: 100%;
			background-color: rgba(#000, 0.4);
			opacity: 1;
			&[progress="100"] {
				opacity: 0;
			}
		}
	}
	// svg{width:100%;height:100%;}
	.view {
		&.noFile {
			&:before {
				position: absolute;
				top: 50%;
				left: 40%;
				width: 20%;
				height: 2px;
				content: "";
				background-color: rgba($neutral, 0.8);
				margin: {
					top: -1px;
				}
			}
			&:after {
				position: absolute;
				top: 40%;
				left: 50%;
				width: 2px;
				height: 20%;
				content: "";
				background-color: rgba($neutral, 0.8);
				margin: {
					left: -1px;
				}
			}
		}
		> svg {
			width: 100%;
			height: 100%;
		}
	}
	.edit {
		position: absolute;
		bottom: -2em;
		left: 0;
		z-index: 2;
		width: 100%;
		height: 2em;
		line-height: 2;
		color: #fff;
		background-color: rgba(#000, 0.6);
		opacity: 0;
	}
	.remove {
		position: absolute;
		top: -1.5em;
		right: 0.2em;
		z-index: 2;
		width: 1.4em;
		height: 1.4em;
		background-color: rgba(#000, 0.6);
		border-radius: 50%;
		fill: #fff;
		svg {
			display: block;
			width: 100%;
			height: 100%;
			font-size: unset;
			transform: scale(0.6);
		}
	}
	&:hover {
		.edit {
			bottom: 0;
			opacity: 1;
		}
		.remove {
			top: 0.2em;
		}
	}
}
.addFile-free {
	min-height: unset;
	.view {
		> * {
			background-position: center;
			background-size: cover;
		}
	}
}
.addFile-m {
	width: 5em;
	.view {
		height: 5em;
	}
	.fileName .name {
		max-width: 5em - 2.6;
	}
}
.addFile-l {
	width: 8em;
	.view {
		height: 8em;
	}
	.fileName .name {
		max-width: 8em - 2.6;
	}
}
.fileName .type {
	max-width: 2.6em;
}
</style>



// WEBPACK FOOTER //
// src/components/common/ui/AddFile.vue